import * as React from 'react';
import cx from 'clsx';
import * as styles from './styles.module.css';

/**
 * Компонент для выстраивания набора лейблов в Контакте
 * Ожидается использование непосредственно в ContactLabels
 */
export var ContactLabel = /*#__PURE__*/React.forwardRef(function Label(_ref, ref) {
  var icon = _ref.icon,
      title = _ref.title,
      href = _ref.href,
      target = _ref.target,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: styles['label']
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: styles['icon']
  }, icon), href ? /*#__PURE__*/React.createElement("a", {
    className: cx(styles['title'], styles['clickable']),
    href: href,
    target: target,
    onClick: onClick
  }, title) : /*#__PURE__*/React.createElement("span", {
    className: cx(styles['title'], onClick && styles['clickable']),
    onClick: onClick
  }, title));
});